module.exports = __webpack_public_path__ + "img/148.b07f04b6.jpg";